export default __webpack_public_path__ + "static/media/Img_AccountType_01.08270a3a.png";